import { render, staticRenderFns } from "./g-editor.vue?vue&type=template&id=f6a7f580"
import script from "./g-editor.vue?vue&type=script&lang=js"
export * from "./g-editor.vue?vue&type=script&lang=js"
import style0 from "./g-editor.vue?vue&type=style&index=0&id=f6a7f580&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports